export default __webpack_public_path__ + "static/media/Add-Address.788f3b80.jpg";